import { userApis } from 'services/UserService/apis';

export const allowShopDevRequest = async ({ shopDevAllowable }: { shopDevAllowable: 'yes' | 'no' }) => {
  return userApis.user.adminApi.allowShopDev({ shopDevAllowable });
};
